import {
    Component
} from '@angular/core';

import {MessageService} from 'primeng/api';
import {faAngleDown, faAngleUp, faSignOut} from "@fortawesome/free-solid-svg-icons";
import {LayoutShopComponent} from "@_basic/layout/shop/layout-shop.component";

@Component({
    selector: 'layout-default',
    standalone: false,
    templateUrl: './layout-default-logged-in-container.component.html',
    styleUrls: ['./layout-default-logged-in-container.component.scss'],
    providers: [MessageService]
})
export class SubLayoutDefaultLoggedInContainerComponent extends LayoutShopComponent {
    showMenu = false;
    protected readonly faSignOut = faSignOut;
    protected readonly faAngleDown = faAngleDown;
    protected readonly faAngleUp = faAngleUp;

    scrollToTop() {
        if(this.isBrowser){
            window.scrollTo(0, 0);
        }
    }
}
